<template>
  <div class="item-price">
    <ym-tag v-if="label"
            class="label ym-line-ellipsis"
            size="small"
            :type="labelType"
            :plain="labelPlain"
    >
      {{ label.text }}
    </ym-tag>
    <price :price="render.price.number"
           :type="render.price.type"
           v-if="render.price"
    />
  </div>
</template>

<script>
  import { Tag } from '@ymba/ym-ui';
  import Price from '@/components/Price';
  import { UI_TAG_TYPE_MAP } from '@/utils/constant';

  export default {
    name: 'ListItemPrice',
    components: {
      YmTag: Tag,
      Price,
    },
    props: {
      render: {
        type: Object,
        required: true,
      },
    },
    computed: {
      label() {
        const { render } = this;
        return render.label;
      },
      labelPlain() {
        return this.label.type === 'highlight';
      },
      labelType() {
        const { label } = this;
        if (label) {
          return UI_TAG_TYPE_MAP[label.type];
        }
        return null;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .item-price {
    align-self: stretch;
    display: inline-flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-bottom: -6px;
  }
</style>
